// gc2 lazy video loader — only loads/plays Instagram-feed videos when scrolled into view
(function () {
  var videos = document.querySelectorAll('[data-gc2-lazy-video]');

  // Posters are rendered as data-gc2-poster (see gc2-instagram-grid.liquid)
  // so they don't download at page load; attach each one shortly before
  // its tile scrolls into view.
  function attachPoster(video) {
    var poster = video.getAttribute('data-gc2-poster');
    if (poster) {
      video.setAttribute('poster', poster);
      video.removeAttribute('data-gc2-poster');
    }
  }

  if (videos.length) {
    if (!('IntersectionObserver' in window)) {
      videos.forEach(function (v) { attachPoster(v); v.preload = 'metadata'; });
    } else {
      var posterObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            attachPoster(entry.target);
            posterObserver.unobserve(entry.target);
          });
        },
        { root: null, rootMargin: '600px 0px' }
      );
      videos.forEach(function (video) { posterObserver.observe(video); });

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var video = entry.target;
            if (entry.isIntersecting) {
              attachPoster(video);
              if (video.preload !== 'auto') video.preload = 'auto';
              var playPromise = video.play();
              if (playPromise && playPromise.catch) playPromise.catch(function () {});
            } else {
              video.pause();
            }
          });
        },
        { root: null, rootMargin: '150px 0px', threshold: 0.25 }
      );
      videos.forEach(function (video) { observer.observe(video); });
    }
  }

  // gc2 floating video card — video tiles pop open a rounded card instead of leaving to Instagram.
  // The page behind stays visible and scrollable; the card just floats on top.
  var lightbox = document.getElementById('gc2InstagramLightbox');
  var lightboxVideo = document.getElementById('gc2InstagramLightboxVideo');
  if (!lightbox || !lightboxVideo) return;

  var shopBar = document.getElementById('gc2InstagramLightboxShop');
  var shopThumbs = document.getElementById('gc2InstagramLightboxShopThumbs');

  var lastFocused = null;
  var closeTimer = null;

  function populateShopBar(tile) {
    if (!shopBar || !shopThumbs) return;
    var fallbackLink = tile.getAttribute('data-gc2-shop-link');

    var items = [1, 2, 3]
      .map(function (n) {
        return {
          src: tile.getAttribute('data-gc2-shop-thumb-' + n),
          href: tile.getAttribute('data-gc2-shop-thumb-' + n + '-link') || fallbackLink
        };
      })
      .filter(function (item) { return item.src && item.href; });

    if (!items.length) {
      shopBar.hidden = true;
      return;
    }

    shopThumbs.innerHTML = '';
    items.forEach(function (item) {
      var link = document.createElement('a');
      link.href = item.href;
      link.className = 'gc2-instagram-lightbox__shop-thumb-link';
      var img = document.createElement('img');
      img.src = item.src;
      img.alt = '';
      img.className = 'gc2-instagram-lightbox__shop-thumb';
      link.appendChild(img);
      shopThumbs.appendChild(link);
    });
    shopBar.hidden = false;
  }

  function openLightbox(tile) {
    var sourceVideo = tile.querySelector('video');
    if (!sourceVideo) return;
    var sourceEl = sourceVideo.querySelector('source');
    var src = sourceVideo.currentSrc || (sourceEl && sourceEl.src);
    if (!src) return;

    if (closeTimer) {
      clearTimeout(closeTimer);
      closeTimer = null;
    }

    lastFocused = document.activeElement;
    lightboxVideo.src = src;
    lightbox.hidden = false;
    populateShopBar(tile);

    // force a reflow so the opening transition actually plays from its starting state
    void lightbox.offsetWidth;
    lightbox.classList.add('is-open');

    var playPromise = lightboxVideo.play();
    if (playPromise && playPromise.catch) playPromise.catch(function () {});
  }

  function closeLightbox() {
    lightbox.classList.remove('is-open');
    lightboxVideo.pause();
    if (shopBar) shopBar.hidden = true;
    if (lastFocused && lastFocused.focus) lastFocused.focus();

    closeTimer = setTimeout(function () {
      lightbox.hidden = true;
      lightboxVideo.removeAttribute('src');
      lightboxVideo.load();
      closeTimer = null;
    }, 350);
  }

  document.querySelectorAll('[data-gc2-video-tile]').forEach(function (tile) {
    tile.addEventListener('click', function (event) {
      event.preventDefault();
      openLightbox(tile);
    });
  });

  lightbox.addEventListener('click', function (event) {
    if (event.target.closest('[data-gc2-lightbox-close]')) closeLightbox();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !lightbox.hidden) closeLightbox();
  });
})();
